import { useMemo, useState } from 'react';
import { Folder } from '../../../types';
import { useFoldersContext } from '../../../contexts/useFolders.context';

export const useParentFolder = (initialFolderId?: Folder['id']) => {
  const { rootFolder } = useFoldersContext();
  const [parentFolderId, setParentFolderId] = useState<Folder['id']>(initialFolderId ?? rootFolder.id);
  const parentFolder = useMemo(() => {
    const rootFolderSubfolders = rootFolder.subfolders || [];
    return findFolderByParentId(rootFolderSubfolders, parentFolderId) || rootFolder;
  }, [rootFolder.subfolders, parentFolderId]);
  const subfolders = parentFolder.subfolders || [];

  return { parentFolder, subfolders, setParentFolderId };
};

export function findFolderByParentId(folders: Folder[], parentFolderId: Folder['id']): Folder | null {
  for (const folder of folders) {
    if (folder.id === parentFolderId) {
      return folder;
    }
    const subfolder = findFolderByParentId(folder.subfolders || [], parentFolderId);
    if (subfolder) {
      return subfolder;
    }
  }
  return null;
}
